module.exports = __webpack_public_path__ + "img/SVN.e896e59c.svg";